import React, { useEffect, useState, useContext, useRef } from 'react';
import { Select, Radio, Button, Checkbox } from 'antd';
import http from '../../../Http';
import utils from '../../../utils';
import config from "../../../Config";
import { useTranslation } from 'react-i18next';
import SvgGroupPvAndInvertersAndLoad from './SvgGroupPvAndInvertersAndLoad';
import InverterList from './InverterList';
import SvgLeft from './SvgLeft';
import SvgRight from './SvgRight';
import SolarYielding from './SolarYielding';
import GridEnergy from './GridEnergy';
import Consumption from './Consumption';
import BatteryEnergy from './BatteryEnergy';
import Power from './Power';
import Energy from './Energy';
import WebSocketController from "../../../WebSocketController";
import moment from 'moment';

function RealtimeMonitorUhomeSinglePhaseCombination(props) {
    const { inverterSelectOptions, SN, protocol, model, isBalcony, handleSelectSN, Once_Combinations } = props;
    const setTip = useContext(utils.tipContext)
    const { t } = useTranslation();

    const [Combinations, setCombinations] = useState([]);
    const [selectedCombinations, setSelectedCombinations] = useState([]);
    const [choiceMode, setChoiceMode] = useState(1);
    const [thirdWidth, setThirdWidth] = useState(640);
    const [refresh, setRefresh] = useState(0);
    const [sns, setSNs] = useState([]);
    const [batSNs, setBatSNs] = useState([]);

    const refContainer = useRef();
    const refInverterList = useRef();
    const refCombinations = useRef();
    const refSelectedCombinations = useRef();


    useEffect(() => {
        if (refContainer.current) {
            setThirdWidth(refContainer.current.getBoundingClientRect().width / 3);
        }
    }, [refContainer])

    useEffect(() => {
        if (Once_Combinations) {
            //将时间转换成浏览器时间
            if (Once_Combinations) {
                let latestTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                Once_Combinations.forEach(v=>{
                    let tz = v["Timezone"]??"UTC";
                    v["LatestTimezone"] = latestTimezone;
                    v["CreateTime"] = utils.convertToLocalTime(v["CreateTime"], tz);
                    if (v["Batteries"]) {
                        v["Batteries"].forEach(b=>{
                            if (b["Alarms"]) {
                                b["Alarms"]["CreateTime"] = utils.convertToLocalTime(b["Alarms"]["CreateTime"], tz);
                            }
                        });
                    }
                })
            }

            setCombinations(Once_Combinations??[]);
            setSelectedCombinations(Once_Combinations);
            refCombinations.current = Once_Combinations;
            refSelectedCombinations.current = Once_Combinations;

            let sns = [];
            sns = Once_Combinations.map((v)=>v.SN);
            setSNs(sns);

            let batSNs = [];
            Once_Combinations.forEach(combination => {
                if (combination.Batteries) {
                    combination.Batteries.forEach(battery => {
                        if (battery.SN) {
                            batSNs.push(battery.SN);
                        }
                    });
                }
            });
            setBatSNs(batSNs);
        }
    }, [Once_Combinations])

    useEffect(() => {
        if (!SN || refresh === 0) {
            return;
        }
        let active = true;

        (async () => {
            let resp = await http.post("integrated-inverter/uhome-singlephase/real-time/get", { SerialNumber: SN }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                return null;
            });

            if (!active) {
                return;
            }

            if (resp === null || resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load inverter details error") });
                return;
            }

           if (resp.data != null) { 
                //将时间转换成浏览器时间
                if (resp.data.Combinations) {
                    let latestTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                    resp.data.Combinations.forEach(v=>{
                        let tz = v["Timezone"]??"UTC";
                        v["LatestTimezone"] = latestTimezone;
                        v["CreateTime"] = utils.convertToLocalTime(v["CreateTime"], tz);
                        if (v["Batteries"]) {
                            v["Batteries"].forEach(b=>{
                                if (b["Alarms"]) {
                                    b["Alarms"]["CreateTime"] = utils.convertToLocalTime(b["Alarms"]["CreateTime"], tz);
                                }
                            });
                        }
                    })
                }

                setCombinations(resp.data.Combinations)
                setSelectedCombinations(resp.data.Combinations)
                refCombinations.current = resp.data.Combinations;
                refSelectedCombinations.current = resp.data.Combinations
                if (resp.data.Combinations) {
                    let ss = resp.data.Combinations.map((v)=>v.SN);
                    if (ss.join("") != sns.join("")) {
                        setSNs(ss);
                    }
                    

                    let bts = [];
                    resp.data.Combinations.forEach(combination => {
                        if (combination.Batteries) {
                            combination.Batteries.forEach(battery => {
                                if (battery.SN) {
                                    bts.push(battery.SN);
                                }
                            });
                        }
                    });
                    if (bts.join("") != batSNs.join("")) {
                        setBatSNs(bts);
                    }
                }
           }

        })();

        return () => {
            active = false;
        };
    }, [SN, refresh])

    const onGotoIvnerterList = () => {
        if (refInverterList.current) {
            refInverterList.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    const handleInverterWSError = (e) => {
        //
    }

    const handleInverterWSDate = (data) => {
        // console.log(data);

        if (data == null || data.InverterSN == null) {
            return;
        }

        if (refCombinations.current == null) {
            return;
        }

        let cs = refCombinations.current;
        for (let i = 0; i < cs.length; i++) {
            if (cs[i].SN == data.InverterSN) {
                let c = cs[i];
                let responseData = JSON.parse(data.Response);
                
                responseData["CreateTime"] = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
                responseData["IsOnline"] = 1;
                Object.assign(c, responseData);
                setCombinations([...cs]);

                break;
            }
        }
        cs = refSelectedCombinations.current??[];
        for (let i = 0; i < cs.length; i++) {
            if (cs[i].SN == data.InverterSN) {
                let c = cs[i];
                let responseData = JSON.parse(data.Response);
                Object.assign(c, responseData);
                setSelectedCombinations([...cs]);
                refSelectedCombinations.current = cs

                break;
            }
        }
    }

    const handleBatteryWSError = (e) => {
        //
    }

    const handleBatteryWSDate = (data) => {
        // console.log(data);

        if (data == null || data.DeviceSN == null || data.MsgID != 0x1001) {
            return;
        }

        if (refCombinations.current == null) {
            return;
        }

        let X = JSON.parse(data.X);
        if (X == null) {
            return;
        }
        X["CreateTime"] = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");

        let cs = refCombinations.current;
        for (let i = 0; i < cs.length; i++) {
            if (!cs[i].Batteries) {
                continue;
            }
            for (let j = 0; j < cs[i].Batteries.length; j++) {
                if (cs[i].Batteries[j].SN == data.DeviceSN) {
                    let bat = cs[i].Batteries[j];
                    if (bat == null) {
                        continue;
                    }
                    if (bat.Alarms == null) {
                        bat.Alarms = X;
                    } else {
                        Object.assign(bat.Alarms, X);
                    }
                }
            }
        }
        if (refSelectedCombinations.current) {
            setSelectedCombinations([...selectedCombinations.current]);
        }
    }

    let master = null;

    const ls = Combinations.map((item, index) => {
        let mode = 1;
        if (item.InverterConnectionMode != null) {
            mode = item.InverterConnectionMode;
        }

        if ((mode == 1 || mode == 2 || mode == 3 || mode == 4) && item.CombinationMasterOrSlave == 1) {
            master = item;
        }

        let checked = false;
        if (selectedCombinations.includes(item)) {
            checked = true;
        }

        return (<div key={index} style={{
            margin: "5px 5px",
            border: "1px solid #d9d9d9",
            borderRadius: "3px",
            padding: "5px 10px"
        }}>{choiceMode == 1 ?                                
            <Checkbox checked={checked} onChange={(e) => {
                if (e.target.checked) {
                    let ss = [...selectedCombinations, item];
                    setSelectedCombinations(ss);
                    refSelectedCombinations.current = ss;
                } else {
                    if (selectedCombinations.length == 1) {
                        return;
                    }
                    refSelectedCombinations.current = refSelectedCombinations.current.filter((i) => i.SN != item.SN)
                    setSelectedCombinations(refSelectedCombinations.current);
                }
            }}><span style={{fontWeight: "bold"}}>{mode==1||mode==2?"(A)":mode==3?"(B)":mode==4?"(C)":""}</span>{item.SN}</Checkbox>
            :
            <Radio value={item.SN}><span style={{fontWeight: "bold"}}>{mode==1||mode==2?"(A)":mode==3?"(B)":mode==4?"(C)":""}</span>{item.SN}</Radio>
        }</div>);
    })

    return (<div ref={refContainer} style={{
        display: 'flex', 
        flexDirection: 'column',
        width: '100%', 
        height: '100%',
        minWidth: '1200px',
        backgroundColor: 'rgb(242, 247, 248)',
        overflowX: 'hidden'
    }}>
        <div style={{
            flex: '1 0 50px',
            padding: "8px",
            backgroundColor: "white",
            display: 'flex',
            alignItems: 'center'
        }}>
            <div style={{flex: "0 1 auto", whiteSpace: "nowrap"}}>{t('Select Inverter')}:&nbsp;</div>
            <Select
                style={{
                    flex: "0 1 auto",
                    minWidth: '210px',
                }}
                showSearch
                placeholder={t("Enter Inverter Name")}
                defaultActiveFirstOption={false}
                showArrow={true}
                filterOption={true}
                onSelect={(value, option) => {
                    handleSelectSN(value, option);
                }}
                value={SN}
            >{inverterSelectOptions}</Select>
            <div style={{
                flex: '1 1 auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
                // flexWrap: 'wrap',
                // alignContent: 'flex-end',
                // justifyContent: 'flex-end',
                padding: "5px 10px",
                marginLeft: "10px",
                borderLeft: "1px solid #d9d9d9",
            }}>
                {Combinations.length > 1 && <>
                    <div style={{
                        display: 'flex',
                    }}>
                        <div style={{flex: '0 0 auto'}}>{t("Parallel Inverters")}:</div>
                        <div style={{
                            flex: '1 1 auto',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                        }}>
                            <Select 
                                defaultValue={1}
                                value={choiceMode}
                                options={[
                                    {
                                        value: 1,
                                        label: t("Multiple Choice")
                                    },
                                    {
                                        value: 2,
                                        label: t("Single Choice")
                                    }
                                ]}
                                onChange={(value) => {
                                    setChoiceMode(value);
                                    if (value == 2) {
                                        refSelectedCombinations.current = [selectedCombinations[0]];
                                        setSelectedCombinations(refSelectedCombinations.current);

                                    }
                                }}
                            />
                            {choiceMode == 1 && <>
                                <div style={{width: "5px"}}></div>
                                <Button type="primary" size="small" onClick={()=>{
                                    refSelectedCombinations.current = Combinations;
                                    setSelectedCombinations(refSelectedCombinations.current);
                                }}>{t("Check All")}</Button>
                            </>}
                        </div>
                    </div>
                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                    }}>
                        {choiceMode == 1 ? ls : <Radio.Group 
                            value={selectedCombinations[0].SN} 
                            style={{
                                width: "100%",
                                display: 'flex',
                                flexDirection: 'row',
                                flexWrap: 'wrap',
                                alignItems: 'flex-start',
                                justifyContent: 'flex-start',
                            }}
                            onChange={(e) => 
                        {
                            Combinations.some((i) => {
                                if (i.SN == e.target.value) {
                                    refSelectedCombinations.current = [i]
                                    setSelectedCombinations(refSelectedCombinations.current);
                                    return true;
                                }
                            })
                        }}>{ls}</Radio.Group>}
                    </div>
                </>}
            </div>
        </div>
        <div style={{
            flex: '0 0 180px', 
            padding: "0 15px",
            backgroundColor: 'transparent',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }}>
            <SolarYielding SN={SN} Combinations={selectedCombinations}/>
            <BatteryEnergy SN={SN} Combinations={selectedCombinations}/>
            <GridEnergy SN={SN} Combinations={selectedCombinations}/>
            <Consumption SN={SN} Combinations={selectedCombinations}/>
        </div>
        <div style={{flex: '0 0 550px'}}>
            <svg width={"100%"} height={550} >
                <rect x="0" y="0" width={thirdWidth*3} height="550" rx="3" style={{ fill: '#fff' }} />
                {/* <rect x={thirdWidth} y="0" width={thirdWidth} height="550" rx="3" style={{ fill: '#eee' }} /> */}
                <SvgLeft x={0} y={0} width={thirdWidth} height={550} master={master} Combinations={selectedCombinations} 
                    handleConverToMonitor={props.handleConverToMonitor}
                    onNavigate={props.onNavigate}
                />
                <SvgGroupPvAndInvertersAndLoad SN={SN} x={thirdWidth} y={0} width={thirdWidth} height={550} Combinations={selectedCombinations} onGotoIvnerterList={onGotoIvnerterList}/>
                <SvgRight x={thirdWidth*2} y={0} width={thirdWidth} height={550} master={master} Combinations={selectedCombinations} onRefresh={() => setRefresh(refresh + 1)}/>
            </svg>
        </div>
        <div ref={refInverterList} style={{ display: master ? "block" : "none", flex: '0 0 300px', backgroundColor:"#fff", position:"relative"}}>
            <InverterList rows={selectedCombinations}/>
        </div>
        <div style={{flex: '0 0 400px', padding: "10px 0px", backgroundColor: 'rgb(242, 247, 248)'}}>
            <Power SelectedCombinations={selectedCombinations} onRefresh={() => setRefresh(refresh + 1)}/>
        </div>
        <div style={{flex: '0 0 400px', backgroundColor: '#fff', position: 'relative'}}>
            <Energy SelectedCombinations={selectedCombinations} />
        </div>
        <WebSocketController 
            baseUrl={config.wssInverterUrl}
            SNs={sns}
            onError={handleInverterWSError}
            onData={handleInverterWSDate}
        />
        <WebSocketController 
            baseUrl={config.wssUrlV2}
            SNs={batSNs}
            onError={handleBatteryWSError}
            onData={handleBatteryWSDate}
        />
    </div>);
}

export default RealtimeMonitorUhomeSinglePhaseCombination